
<template>
  <div id="base" class="app">
    <GoogleMap
      :activeHouse="activeHouse"
      :houses="houses"
      @setActiveHouse="setActiveHouse"
    />
    <main>
      <PeopleFilter
        @filterChange="handleFilterChange"
       />
      <div class="app__content">
        <div v-if="activeHouse">
          <h2 class="house__title">
            Dům č.p.: {{activeHouse}}
            <a
              class="house__link-back"
              @click.prevent='clearActiveHouse'
            >
              &times;
            </a>
          </h2>
          <p class="house__info">{{houses[activeHouse].info}}</p>
        </div>
        <div class="app__people">
          <PersonItem v-for="person in people" v-show="visiblePerson(person)" :activePerson="activePerson" :person="person" :key="person.id" />
        </div>
      </div>
    </main>
    <transition name="fade">
      <PersonDetail v-if="activePerson" :person="activePerson" />
    </transition>
  </div>
</template>

<script>
import people from "../data/people.json";
import houses from "../data/houses.json";

import PersonItem from "@/components/PersonItem.vue";
import PeopleFilter from "@/components/PeopleFilter.vue";
import GoogleMap from "@/components/GoogleMap.vue";
import PersonDetail from "@/components/PersonDetail.vue";

export default {
  data() {
    return {
      people,
      houses,
      activePerson: null,
      activeHouse: null,
      filter: {
        filterAge: "any",
        filterGender: "any",
        filterSearch: "",
        filterSurvive: "any"
      }
    };
  },
  components: {
    PersonItem,
    PeopleFilter,
    GoogleMap,
    PersonDetail
  },
  created() {
    this.setPerson();
  },
  watch: {
    "$route.params.personId"() {
      this.setPerson();
    }
  },
  methods: {
    visiblePerson(person) {
      const {
        filterGender,
        filterSurvive,
        filterAge,
        filterSearch
      } = this.filter;
      const { gender, survive, birthDate, house, name, surname } = person;
      const fullName = `${name} ${surname}`;
      const fullNameReverse = `${surname} ${name}`;
      const age = 1942 - parseInt(birthDate, 10);
      const isAdult = age >= 15 ? 1 : 0;
      const match =
        (gender === parseInt(filterGender, 10) || filterGender === "any") &&
        (survive === filterSurvive || filterSurvive === "any") &&
        (isAdult === parseInt(filterAge, 10) || filterAge === "any") &&
        (house === this.activeHouse || this.activeHouse === null) &&
        (fullName.toLowerCase().includes(filterSearch.toLowerCase()) ||
          fullNameReverse.toLowerCase().includes(filterSearch.toLowerCase()) ||
          filterSearch === "");
      return match;
    },
    setPerson() {
      this.activePerson = this.people.find(
        p => p.id === parseInt(this.$route.params.personId, 10)
      );
    },
    clearFilter(form) {
      this.filterAge = "any";
      this.filterGender = "any";
      this.filterSurvive = "any";
      this.filterSearch = "";
      form.reset();
    },
    clearActiveHouse() {
      this.activeHouse = null;
    },
    handleFilterChange(filter) {
      this.filter = filter;
    },
    setActiveHouse(house) {
      this.activeHouse = house.id;
    }
  }
};
</script>

<style scoped>
main {
  position: relative;
  background-color: var(--colorGray2);
  min-height: 100vh;
}

@media (min-width: 768px) {
  main {
    margin-left: calc(100% - (100% / 1.618));
  }
}

.app__people {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0.5rem;
}

/* house */
.house__title {
  font-weight: 300;
  text-align: center;
  font-size: 2.5rem;
  margin: 1rem 1rem 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.house__link-back {
  text-decoration: none;
  color: var(--colorPrimary);
  font-size: 4rem;
  line-height: 0;
  transition: all 300ms ease-in-out;
  cursor: pointer;
}

.house__link-back:hover {
  opacity: 0.8;
}

.house__info {
  display: block;
  text-align: center;
  margin: 0 1rem 1rem 1rem;
}
</style>
